import { useCallback, useEffect, useState } from "react";

import CryptoJS from "crypto-js";
import { isToday, parse } from "date-fns";

import server from "../../functions/server";
import { api } from "../../services/axios";
import Cookies from "js-cookie";
import { supportNumber } from "../../utils/supportNumber";

export const useHome = () => {
  const [banners, setBanners] = useState(null);
  const [bannersLoading, setBannersLoading] = useState(true);
  const [partnerName, setPartnerName] = useState("");

  const [splitsData, setSplitsData] = useState([]);
  const [splitsLoading, setSplitsLoading] = useState(true);

  const [ordersData, setOrdersData] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);

  const [anouncements, setAnouncements] = useState([]);
  const [anouncementsLoading, setAnouncementsLoading] = useState(true);

  const handleGetBanner = useCallback(async () => {
    try {
      setBannersLoading(true);
      const { data: bannerResponse } = await api.get("/portalCliente/banners");

      setBanners(bannerResponse);
    } catch (error) {
      console.error("Error fetching banners:", error);
      setBanners([]);
    } finally {
      setBannersLoading(false);
    }
  }, []);

  const handlePartnerName = useCallback(() => {
    try {
      let name = localStorage.getItem("nomeparc");
      name = CryptoJS.AES.decrypt(name, "MedSys@341");
      name = CryptoJS.enc.Utf8.stringify(name).trim();

      setPartnerName(name);
    } catch (error) {
      console.error("Error decrypting partner name:", error);
      setPartnerName("");
    }
  }, []);

  const handleGetSplits = useCallback(({ splits }) => {
    let data = splits;

    try {
      data = JSON.parse(splits);
      setSplitsLoading(false);
    } catch (error) {
      console.error("Error parsing splits data:", error);
    }

    const newData = data.filter(
      (unico) => unico[8] == null && unico[10] && unico[4] !== "NOTA"
    );

    const rows = newData.map((linha, index) => ({
      id: index,
      nota: linha[0],
      vencimento: linha[2],
      valor: linha[4] === "VENDOR" ? "" : linha[3],
      status: linha[4] === "Em aberto" ? "Aberto" : linha[4],
      nufin: linha[5],
      codbco: linha[6],
      linha_digitavel: linha[10],
      nossonum: linha[11],
    }));

    setSplitsData(rows);
  }, []);

  const handleGetOrders = useCallback(({ orders }) => {
    let data = orders;

    try {
      data = JSON.parse(orders);
      setOrdersLoading(false);
    } catch (error) {
      console.error("Error parsing orders data:", error);
    }

    const newData = data?.filter?.((unico) => unico[3] === "N");

    setOrdersData(newData);
  }, []);

  const handleGetAnnouncements = useCallback(async () => {
    try {
      setAnouncementsLoading(true);
      const { data: anouncementsResponse } = await api.get(
        "/portalCliente/comunicados"
      );

      const filtered = anouncementsResponse.filter((item) => {
        if (!item.publication) return false;
        const parsed = parse(item.publication, "dd/MM/yyyy", new Date());
        return isToday(parsed);
      });

      setAnouncements(filtered);
    } catch (error) {
      console.error("Error fetching anouncements:", error);
    } finally {
      setAnouncementsLoading(false);
    }
  }, []);

  const downloadFile = (base64Data) => {
    const linkSource = `data:application/pdf;base64,${base64Data}`;
    const iframeContainer = document.createElement("div");
    iframeContainer.style.width = "100%";
    iframeContainer.style.height = "100vh";
    iframeContainer.style.position = "fixed";
    iframeContainer.style.top = "0";
    iframeContainer.style.left = "0";
    iframeContainer.style.backgroundColor = "rgba(0,0,0,0.8)";
    iframeContainer.style.zIndex = "9999";
    iframeContainer.style.display = "flex";
    iframeContainer.style.justifyContent = "center";
    iframeContainer.style.alignItems = "center";

    const closeButton = document.createElement("button");
    closeButton.innerHTML = "X";
    closeButton.style.position = "absolute";
    closeButton.style.top = "20px";
    closeButton.style.right = "20px";
    closeButton.style.padding = "10px 20px";
    closeButton.style.backgroundColor = "#fff";
    closeButton.style.border = "none";
    closeButton.style.borderRadius = "5px";
    closeButton.style.cursor = "pointer";
    closeButton.onclick = () => document.body.removeChild(iframeContainer);

    const iframe = document.createElement("iframe");
    iframe.src = linkSource;
    iframe.style.width = "90%";
    iframe.style.height = "90%";
    iframe.style.border = "none";

    iframeContainer.appendChild(closeButton);
    iframeContainer.appendChild(iframe);
    document.body.appendChild(iframeContainer);
  };

  const cons_boleto = async (
    numfin,
    codbanc,
    status,
    linha_digitavel,
    nossonum
  ) => {
    let user = localStorage.getItem("user");
    user = CryptoJS.AES.decrypt(user, "MedSys@341");
    user = CryptoJS.enc.Utf8.stringify(user);

    if (status === "VENDOR") {
      return window.open(
        `https://wa.me/${supportNumber.whatsApp}/?text=Solicito a segunda via de boleto VENDOR`
      );
    }

    if (status === "DAYCOVAL") {
      return downloadFile(linha_digitavel, "boleto.pdf");
    }

    const url = `${server}portalCliente/consulta/boleto`;

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("bearer"),
      },
      body: JSON.stringify({
        jsonid: localStorage.getItem("token"),
        nufin: `${numfin}`,
        codbco: `${codbanc}`,
        linha_digitavel: linha_digitavel.replace(/\D/g, ""),
        status: "Em aberto",
        cnpj: user,
        nossonum,
      }),
    })
      .then((resp) => resp.text())
      .then((reqres) => {
        const resp = JSON.parse(reqres);

        if (resp.boleto === "") {
          return cons_boleto(
            numfin,
            codbanc,
            "Vencido",
            linha_digitavel,
            nossonum
          );
        }
        const fileUrl = `${server}arquivos/boleto/${resp.boleto}.pdf`;

        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64data = reader.result.split(",")[1];
              downloadFile(base64data, "boleto.pdf");
            };
            reader.readAsDataURL(blob);
          })
          .catch((error) => console.error("Error fetching the file:", error));
      })
      .catch(() => {
        // eslint-disable-next-line no-alert
        window.alert("A sua sessão expirou");
        window.location.href = "/portal";
      });
  };

  useEffect(() => {
    handleGetBanner();
    handlePartnerName();
    handleGetAnnouncements();
  }, [handleGetBanner, handlePartnerName, handleGetAnnouncements]);

  return {
    banners,
    partnerName,
    handleGetSplits,
    splitsData,
    splitsLoading,
    handleGetOrders,
    ordersData,
    ordersLoading,
    anouncements,
    anouncementsLoading,
    bannersLoading,
    cons_boleto,
  };
};
